import React from 'react';

export default ({ children }) =>
  <div style={{ margin: '3rem auto', maxWidth: 960 }}>
    {children}
  </div>


// WEBPACK FOOTER //
// ./src/components/container/index.js